import { render, staticRenderFns } from "./myBookshelf.vue?vue&type=template&id=21304ccc&scoped=true&"
import script from "./myBookshelf.vue?vue&type=script&lang=js&"
export * from "./myBookshelf.vue?vue&type=script&lang=js&"
import style0 from "./myBookshelf.vue?vue&type=style&index=0&id=21304ccc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21304ccc",
  null
  
)

export default component.exports